import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const [state, setState] = useState("loading");

  useEffect(() => {
    document.title = "Unsubscribe | Hussar Treasury";
    const token = params.get("token");
    if (!token) {
      setState("invalid");
      return;
    }
    api.post("/newsletter/unsubscribe", { token })
      .then(() => setState("done"))
      .catch(() => setState("invalid"));
  }, [params]);

  return (
    <div data-testid="unsubscribe-page" className="pt-48 pb-40 px-6 text-center max-w-xl mx-auto">
      {state === "loading" && <p className="text-hussar-muted font-mono text-xs uppercase tracking-widest">Processing…</p>}
      {state === "done" && (
        <>
          <div className="metadata-label mb-6">Weekly Intelligence</div>
          <h1 className="font-serif text-3xl sm:text-4xl text-hussar-ink mb-6">You have been unsubscribed.</h1>
          <p className="text-hussar-slate font-light mb-10">No further editions will be sent. The record remains, should you ever wish to return.</p>
          <Link to="/" data-testid="unsubscribe-home-link" className="btn-ghost">Return to Hussar Treasury</Link>
        </>
      )}
      {state === "invalid" && (
        <>
          <h1 className="font-serif text-3xl sm:text-4xl text-hussar-ink mb-6">This unsubscribe link is not valid.</h1>
          <p className="text-hussar-slate font-light mb-10">It may have already been used or has expired.</p>
          <Link to="/" className="btn-ghost">Return to Hussar Treasury</Link>
        </>
      )}
    </div>
  );
}
